import React, { useEffect, useState } from 'react';
import { makeStyles } from 'design-system/product/theme';
import { Typography } from 'design-system/product';

const useStyles = makeStyles(theme => ({
  dateCardOverlay: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: '#fff',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    zIndex: 10000,
  },
  dateText: {
    fontWeight: 'bold',
  },
}));

const DateCardOverlay = () => {
  const classes = useStyles();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const formatDate = (date: Date) => {
    return date.toLocaleDateString();
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={classes.dateCardOverlay}>
      <Typography variant="body2" className={classes.dateText}>
        {formatDate(currentDateTime)}
      </Typography>
      <Typography variant="body2" className={classes.dateText}>
        {formatTime(currentDateTime)}
      </Typography>
    </div>
  );
};

export default DateCardOverlay;
